var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:connection"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43 27V29.875H30.625C28.1054 29.875 25.6891 30.8759 23.9075 32.6575C22.1259 34.4391 21.125 36.8554 21.125 39.375V48.125C21.125 50.6446 22.1259 53.0609 23.9075 54.8425C25.6891 56.6241 28.1054 57.625 30.625 57.625H52.5C55.0196 57.625 57.4359 56.6241 59.2175 54.8425C60.9991 53.0609 62 50.6446 62 48.125V39.375C62 37.7074 61.561 36.0693 60.7272 34.6251C59.9667 33.3079 58.9021 32.1944 57.625 31.3762V28.1047C61.9023 30.0541 64.875 34.3662 64.875 39.3706V48.1206C64.875 51.4027 63.5712 54.5503 61.2504 56.8711C58.9297 59.1918 55.7821 60.4956 52.5 60.4956H30.625C27.3429 60.4956 24.1953 59.1918 21.8746 56.8711C19.5538 54.5503 18.25 51.4027 18.25 48.1206V39.375C18.25 36.0929 19.5538 32.9453 21.8746 30.6246C24.1953 28.3038 27.3429 27 30.625 27H43Z",
    fill: "#EA3E2A",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.375 38.6238V41.8955C10.385 40.9895 8.66411 39.5695 7.39478 37.7734C5.91726 35.6827 5.12426 33.1853 5.125 30.6252V30.625V21.875C5.125 18.5929 6.42879 15.4453 8.74955 13.1246C11.0703 10.8038 14.2179 9.5 17.5 9.5H39.375C42.6571 9.5 45.8047 10.8038 48.1254 13.1246C50.4462 15.4453 51.75 18.5929 51.75 21.875V30.625C51.75 33.9071 50.4462 37.0547 48.1254 39.3754C45.8047 41.6962 42.6571 43 39.375 43H27V40.125H39.375C41.8946 40.125 44.3109 39.1241 46.0925 37.3425C47.8741 35.5609 48.875 33.1446 48.875 30.625V21.875C48.875 19.3554 47.8741 16.9391 46.0925 15.1575C44.3109 13.3759 41.8946 12.375 39.375 12.375H17.5C14.9804 12.375 12.5641 13.3759 10.7825 15.1575C9.00089 16.9391 8 19.3554 8 21.875V30.625C8.00004 32.2926 8.43902 33.9307 9.27282 35.3749C10.0333 36.6921 11.0979 37.8056 12.375 38.6238Z",
    fill: "#EA3E2A",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpConnection);
export default __webpack_public_path__ + "static/media/ep_connection.f0776a6b300be85e7f6c41ba4bf5f6ab.svg";
export { ForwardRef as ReactComponent };